import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import config from './config';
import { getLocalProfile } from './providers/auth.service';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'proxy-polyfill'

const bugsnagReleaseStages = ['DEV', 'PROD', 'STAGING'] // prevent local error reporting

Bugsnag.start({
  apiKey: config.BUGSNAG_KEY,
  plugins: [new BugsnagPluginReact()],
  releaseStage: process.env.REACT_APP_ENV,
  enabledReleaseStages: bugsnagReleaseStages,
  // Locally there is nothing to report to, so don't start a session (it only logs "Session not sent")
  autoTrackSessions: bugsnagReleaseStages.includes(process.env.REACT_APP_ENV ?? ""),
  onError: function (event) {
    try {
      const profile = getLocalProfile();
      const data = JSON.parse(profile || "");
      event.setUser(data[`https://facecheck.ai/tenantId`], data[`email`], data[`nickname`]);
    } catch (e) {}
  }
})

const ErrorBoundary = Bugsnag.getPlugin('react')?.createErrorBoundary(React) as React.ComponentClass;

// No StrictMode: Material-UI 4 transitions (react-admin's notifications, menus) still use findDOMNode,
// which StrictMode reports on every page. StrictMode only adds development checks, so production is unchanged
ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById('root')
);

